"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'currency.error.missingCurrencyCode': 'Il codice valuta è richiesto',
    'currency.error.failedToGetRate': 'Errore nel recuperare il tasso di cambio',
    'currency.error.missingConversionParams': 'Valuta di origine, valuta di destinazione e importo sono richiesti',
    'currency.error.invalidAmount': 'L\'importo deve essere un numero positivo',
    'currency.error.failedToConvert': 'Errore nella conversione della valuta',
    'currency.error.failedToGetCurrencies': 'Errore nel recuperare l\'elenco delle valute',
    'currency.error.failedToGetSupportedCurrencies': 'Errore nel recuperare le valute supportate',
    'currency.error.missingHistoricalParams': 'Codice valuta, data di inizio e data di fine sono richiesti',
    'currency.error.invalidDateFormat': 'Il formato della data deve essere YYYY-MM-DD',
    'currency.error.failedToGetHistoricalRates': 'Errore nel recuperare i tassi storici',
    'currency.error.failedToGetGoldPrice': 'Errore nel recuperare il prezzo dell\'oro',
};
